export interface LogoProps {
  className?: string;
}

export function Logo({ className = 'w-10 h-10' }: LogoProps) {
  return (
    <img
      src="/logo.svg"
      alt="PCNGuard Logo"
      loading="lazy"
      decoding="async"
      className={className}
    />
  );
}

export default Logo;
